import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    root: props => (
        {
            display:"flex",
            alignItems:"center",
            justifyContent:"stretch",
            "& h6":{
                marginRight:theme.spacing(1)
            }
        }
    ),
    regular_price: props => (
        {
            textDecoration: props.price < props.regular_price ? "line-through" : "",
            color: theme.palette.error.main
        }
    )

}))

const ProductPrice = props => {
    const {price,regular_price,sale_price} = props

    const classes = useStyles(props);

    const hasDiscount = price < regular_price

    return (
        <Box className={classes.root} >
            <Typography variant="h6"  >${price}</Typography>
            {hasDiscount && <Typography variant="h6" className={classes.regular_price} >${regular_price}</Typography>}
        </Box>
    )
}

ProductPrice.propTypes = {

}

ProductPrice.defaultProps = {
    price:0,
    regular_price:0,
    sale_price:0,    
};

export default ProductPrice
